import qs from 'qs'
import { FileItem, FolderItem } from '@nyanyajs/utils/dist/saass'
import { alert, snackbar } from '@saki-ui/core'
import i18n from './i18n/i18n'
import { AES } from '@nyanyajs/utils'
import store from '../store'

import { api } from '../modules/electron/api'
import md5 from 'blueimp-md5'
import { pwdKey } from '../config'

const t = i18n.t

export const Query = (
  url: string,
  query: {
    [k: string]: string
  },
  searchParams?: URLSearchParams
) => {
  let obj: {
    [k: string]: string
  } = {}
  searchParams?.forEach((v, k) => {
    obj[k] = v
  })
  let o = Object.assign(obj, query)
  let s = qs.stringify(
    Object.keys(o).reduce(
      (fin, cur) => (o[cur] !== '' ? { ...fin, [cur]: o[cur] } : fin),
      {}
    )
  )
  return url + (s ? '?' + s : '')
}

export const encryptContent = (content: string, pwd: string) => {
  const params = {
    c: content || "<p><br></p>",
  }

  console.log("encryptContent", params)
  return AES.encrypt(
    params,
    pwd
  )?.value
}

export const decryptContent = (content: string, pwd: string) => {
  try {
    const deContent = AES.decrypt(content, pwd)
    console.log("decryptContent", content, 1, deContent, 2, pwd)
    return JSON.parse(AES.decrypt(content, pwd))?.c || ''
  } catch (error) {
    console.error(error)
    return ''
  }
}

export const getPwd = (pwd: string) => {
  return md5(pwd + pwdKey)
}


export const copyText = (content: string) => {
  const { config } = store.getState()
  const d = document.createElement('div')
  d.innerHTML = content
  // content = content.replace(/<\/?.+?>/g, '')
  // console.log(content)
  if (window.isSecureContext && navigator.clipboard) {
    navigator.clipboard.writeText(d.innerText)
  } else {
    const textArea = document.createElement('textarea')
    textArea.value = d.innerText
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    try {
      document.execCommand('copy')
    } catch (err) {
      console.error('Unable to copy to clipboard', err)
    }
    document.body.removeChild(textArea)
  }

  // showNotification
  // api.showNotification

  switch (config.platform) {
    case 'Electron':
      api.showNotification({
        title: t('copySuccessfully', {
          ns: 'common',
        }),
        content: content,
        timeout: 3000,
      })
      config.general.autoCloseWindowAfterCopy && api.hideWindow()
      break
    case 'Web':
      snackbar({
        message: t('copySuccessfully', {
          ns: 'common',
        }),
        vertical: 'top',
        horizontal: 'center',
        autoHideDuration: 2000,
        // closeIcon: true,

        backgroundColor: 'var(--saki-default-color)',
        color: '#fff',
      }).open()
      break

    default:
      break
  }
}


export const readClipboardText = async () => {
  try {
    return await navigator.clipboard?.readText?.()
  } catch (error) {
    console.error(error)

  }
}


export const goTo = (url: string) => {
  const { config } = store.getState()
  switch (config.platform) {
    case 'Electron':
      const { shell } = window.require('electron')
      shell.openExternal(url)
      break
    case 'Web':
      window.open(url)
      break

    default:
      break
  }
}